<template>
    <div class="user-detail">
        <div class="back-btn">
            <el-button type="primary" @click="goback">返回</el-button>
        </div>
        <div class="user-name">
            
            <i class="el-icon-menu bigger"/>
            {{ cName }}
        </div>
        
        <el-row class="user-info">
        <el-col :span="5">
            <div class>客户代码:{{ custom.customerCode }}</div>
        </el-col>
        <el-col :span="5">
            <div class>对接人:{{ custom.contacts }}</div>
        </el-col>
        <el-col :span="5">
            <div class>对接人手机:{{ custom.contactsNumber }}</div>
        </el-col>
        <el-col :span="9">
            <div class>客户地址:{{ custom.address }}</div>
        </el-col>
        </el-row>

        <el-row class="header" style="width: 100%;">
        <div class="btns">
        </div>
        <div>
            <div style="font-size: 24px; font-weight: 600; margin-right: 15px;">
            <span>当前点数：</span>
            <span style="font-weight: 500;color: #03BF16;" v-if="judgeInfo.checkType === 1">店铺{{ judgeInfo.storeCount }}个（各门店{{ judgeInfo.userCount }}人）</span>
            <span style="font-weight: 500;color: #03BF16;" v-else-if="judgeInfo.checkType === 3">{{ judgeInfo.userCount }}人</span>
            <span style="font-weight: 500;color: #03BF16;" v-else>--</span>          
            </div>
        </div>
        </el-row>

        <div class="prod">
        <el-table ref="multipleTable" :data="proDetail" tooltip-effect="dark" style="width: 100%">
            <el-table-column prop="productCode" label="产品编号"/>
            <el-table-column prop="productName" label="产品名称"/>
            <el-table-column prop="macCode" label="MAC机器码"/>
            <el-table-column label="授权类型">
                <template slot-scope="scope">
                    <!-- <div>{{ scope.row.checkType == 1 ? "按门店及导购授权" : "按导购点数授权" }}</div> -->
                    <span v-if="scope.row.checkType == 1">按门店及导购授权</span>
                    <span v-else-if="scope.row.checkType == 3">按导购点数授权</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column prop="shopNum" label="店铺数量"/>
            <el-table-column prop="userNum" label="导购数量"/>
            <el-table-column label="使用期限">
                <template slot-scope="scope">
                    <div>{{ scope.row.startDate }}~{{ scope.row.endDate }}</div>
                </template>
            </el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <div v-if="scope.row.isExpired === 1" style="color: #D9001B;">已过期</div>
                    <div v-else-if="scope.row.isExpired === 0 && scope.row.state === 1" style="color: #70B603;">正常</div>
                    <div v-else-if="scope.row.isExpired === 0 && scope.row.state === 2" style="color: #D9001B;">已取消</div>
                    <div v-else>--</div>
                </template>
            </el-table-column>
            <el-table-column prop="updateDate" label="授权日期"/>
        </el-table>
        </div>
        <div class="pagination-main">
        <el-pagination
            :current-page="post.page"
            :page-size="post.size"
            :total="pageCount"
            :page-sizes="[10, 50, 100, 200]"
            layout="sizes, prev, pager, next, jumper"
            @size-change="sizeChange"
            @current-change="pageChange"/>
        </div>
    </div>
</template>

<script>
import { getData } from '@/api/api'
export default {
data() {
    return {
    custom: {
        customerCode: '',
        contacts: '',
        contactsNumber: '',
        address: ''
    },
    count: 5,
    activeName: '1',
    cName: '',
    proDetail: [],
    dialogVisible: false,
    showClose: false,
    changeDate: {},
    dialogName: '',
    formLabelWidth: '100px',
    pros: [],
    deleteId: '',
    showDlog: false,
    authTitle: '',
    authMsgs: '',
    proName: '',
    proCode: '',
    post: {
        cid: '',
        page: 1,
        size: 10
    },
    pageCount: null,
    judgeInfo: {}
    }
},
mounted() {
    this.post.cid = this.$route.query.cid
    this.cName = this.$route.query.cName
    this.fetchDatas()
},
methods: {
    // 修改授权类型
    fetchDatas() {
        this.listLoading = true
        const posts = {
            id: this.post.cid
        }
        getData('/detail.api', posts).then(res => {
            console.log(res)
            this.custom = res.data
            this.fetchPros()
        })
    },
    fetchPros() {
        this.listLoading = true
        getData('/getCustomerUserCount.api', { id: this.post.cid }).then(res => {
            if(res.data) {
            this.judgeInfo = res.data
            } else {
            this.judgeInfo = {}
            }        
        })
        getData('/products.api', this.post).then(res => {
            console.log(res)
            this.proDetail.length = 0
            this.pageCount = res.data.total
            this.proDetail.push(...res.data.list)
            this.listLoading = false
        })
    },
    sizeChange(e) {
        this.post.size = e
        this.fetchPros()
    },
    pageChange(e) {
        this.post.page = e
        this.fetchPros()
    },
    goback(){
        this.$router.go(-1)
    }
}
}
</script>

<style scoped>
.user-detail {
    min-height: calc(100vh - 50px);
    background-color: #f2f2f2;
    padding: 10px 15px 0 15px;
}
.back-btn {
    display: flex;
    justify-content: flex-start;
}
.user-info {
    height: 57px;
    line-height: 24px;
    background-color: #ffffff;
    padding: 13px 0 20px 0;
    color: #13ce66;
    font-size: 14px;
    text-align: center;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.btns {
    flex: 1;
    margin: 15px 0;
    background-color: transparent;
    padding-left: 15px;
}
.prod {
    background-color: #ffffff;
    padding: 1px 20px 5px 20px;
    margin-top: 10px;
    
}

.pagination-main {
    text-align: center;
    margin-top: 20px;
}

.user-name {
    height: 55px;
    /*margin-top: 7px;*/
    line-height: 75px;
    background-color: #ffffff;
    /*padding-left: 15px;*/
    padding: 1px 20px 5px 20px;
    border-bottom: 1px dashed #cccccc;
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/detail.vue